import { Button, Modal, Row, message } from "antd";
import { RenderInputProps } from "../types";
import { useFlow } from "../../../FlowEdit/useFlow";
import { ProList } from "@ant-design/pro-components";

import { ResponseCode } from "../../../../../constants";
import TextInput from "./TextInput";
import { useState } from "react";
import MaterialCard from "../../../../../MaterialCard";
import { usePageConfig } from "../../../../PageConfigProvider";
import {
  MaterialType,
  queryMaterialPageService,
} from "../../../../services/material";

type FormData = {
  uploadTime: string[];
  maxUploadTime: string;
  minUploadTime: string;
  name: string;
  tagList: string[];
};

export default function SelectedMaterial({
  item,
  moduleId,
  inputs,
}: RenderInputProps) {
  const { defaultValue } = usePageConfig();
  const flowId: string = (defaultValue?.id as string) || "";
  const { updateNodeValue } = useFlow();
  const [open, setOpen] = useState(false);

  const [checkedName, setCheckedName] = useState("");

  return (
    <>
      <Row>
        <TextInput item={item} moduleId={moduleId} inputs={inputs} />
        <Button type="primary" onClick={() => setOpen(true)}>
          素材库
        </Button>
      </Row>
      <Modal
        title="素材库"
        open={open}
        onCancel={() => setOpen(false)}
        width={"80vw"}
        destroyOnClose
        okText="确认"
        cancelText="取消"
        onOk={() => {
          if (!checkedName) {
            message.info("请选择素材");
            return;
          }
          setCheckedName("");
          setOpen(false);
          updateNodeValue(moduleId, item.key, checkedName);
        }}
      >
        <ProList<MaterialType, FormData>
          search={{}}
          request={async ({
            pageSize,
            current,
            name,
            minUploadTime,
            maxUploadTime,
          }) => {
            const rsp = await queryMaterialPageService({
              pageSize: pageSize ?? 0,
              pageNum: current ?? 0,
              name,
              minUploadTime,
              maxUploadTime,
              flowId,
            });
            return {
              data: rsp.data?.records,
              success: rsp.code === ResponseCode.Success,
              total: rsp.data?.total,
            };
          }}
          grid={{ gutter: 24, column: 5 }}
          pagination={{ defaultPageSize: 10 }}
          renderItem={(item) => {
            return (
              <div style={{ padding: 4 }}>
                <MaterialCard
                  material={item}
                  checked={checkedName === item.name}
                  onChange={function (_id: string, item: MaterialType): void {
                    setCheckedName(item.name);
                  }}
                  showUncheckButton={!!checkedName}
                  showDeleteButton={false}
                  canEditName={false}
                  showCopyButton={true}
                />
              </div>
            );
          }}
          metas={{
            name: {
              title: "文件名称",
              valueType: "text",
            },
            uploadTime: {
              title: "上传时间",
              valueType: "dateRange",
              search: {
                transform: (v: string[]) => {
                  return {
                    minUploadTime: v[0],
                    maxUploadTime: v[1],
                  };
                },
              },
            },
          }}
        />
      </Modal>
    </>
  );
}
